module.exports = __webpack_public_path__ + "static/media/资源三号卫星.276ae3c7.png";